import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

import { sharesReachConfig } from '../sharesReach';

export const sharesReachMVConfig = {
    ...sharesReachConfig,
    orientation: ORIENTATION_VERTICAL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
